require('./lbaAddGridResource.scss');

const $inject = [];

const lbaAddGridResource = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaAddGridResourceCtrl',
    controllerAs: 'vm',
    template: require('./lbaAddGridResource.html')
  }
};

lbaAddGridResource.$inject = $inject;

export default lbaAddGridResource;



// WEBPACK FOOTER //
// ./src/components/lbaAddGridResource/lbaAddGridResourceDir.js